import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeWalletRechargeSuccessModal, fetchWalletLedger } from '../../../../store/walletSlice';
import { useWalletHydration } from './hooks/useWalletHydration';
import { useWalletRechargeHandlers } from '../../../../hooks/useWalletRechargeHandlers';
import { WalletBalanceCard } from './WalletBalanceCard';
import { WalletTransactionLedger } from './WalletTransactionLedger';
import { RechargeWalletModal } from './modals/RechargeWalletModal';
import { WalletRechargeSuccessModal } from './modals/WalletRechargeSuccessModal';

export function MetaWalletTab({ phoneNumber, showRechargeModal, setShowRechargeModal }) {
  useWalletHydration();

  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.auth?.user?.companyId);
  const wallet = useSelector((state) => state.wallet);
  const pendingPaymentRef = useRef(null);

  useEffect(() => {
    if (companyId && !wallet.ledgerFetched && !wallet.ledgerLoading) {
      dispatch(fetchWalletLedger());
    }
  }, [companyId, wallet.ledgerFetched, wallet.ledgerLoading, dispatch]);

  const [gstNumber, setGstNumber] = useState('');

  const { handleInitiateWalletRecharge, isRechargeProcessing } = useWalletRechargeHandlers({
    setShowRechargeModal,
    pendingPaymentRef,
  });

  return (
    <div className="space-y-5 animate-fade-in-up">
      <WalletBalanceCard
        balance={wallet.balance}
        warningThreshold={wallet.warningThreshold}
        onRecharge={() => setShowRechargeModal(true)}
      />

      <WalletTransactionLedger transactions={wallet.transactions} />

      <RechargeWalletModal
        open={showRechargeModal}
        onOpenChange={setShowRechargeModal}
        onProceedToPayment={handleInitiateWalletRecharge}
        gstNumber={gstNumber}
        onGstNumberChange={setGstNumber}
        isProcessing={isRechargeProcessing}
      />

      <WalletRechargeSuccessModal
        open={wallet.showRechargeSuccessModal}
        onOpenChange={() => dispatch(closeWalletRechargeSuccessModal())}
        transactionDetails={wallet.lastRechargeDetails}
        onGoToWallet={() => dispatch(closeWalletRechargeSuccessModal())}
      />
    </div>
  );
}
